import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Modal, Button } from "react-bootstrap";
const initialDocumentValues = {
  documentName: "",
  imageName: "",
  imageFile: null,
  imageSrc: "",
};
export default function DocumentModal({
  currentServiceTask,
  setDocumentModalVisible,
  headerconfig,
}) {
  const [documentValues, setDocumentValues] = useState(initialDocumentValues);
  const [documents, setDocuments] = useState([]);
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (currentServiceTask) {
      GetDocuments(currentServiceTask.serviceTaskId);
    }
    GetUserData();
  }, [currentServiceTask]);
  const handleDocumentInputChange = (e) => {
    const { name, value } = e.target;
    setDocumentValues({
      ...documentValues,
      [name]: value,
    });
  };
  const resetDocumentForm = () => {
    setDocumentValues(initialDocumentValues);
  };
  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setDocumentValues({
          ...documentValues,
          imageFile,
          imageSrc: x.target.result,
        });
      };
      reader.readAsDataURL(imageFile);
    } else {
      setDocumentValues({
        ...documentValues,
        imageFile: null,
        imageSrc: "",
      });
    }
  };
  const validate = () => {
    let temp = {};
    temp.documentName = documentValues.documentName.trim() !== "";
    temp.imageFile = documentValues.imageFile !== null;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("documentName", documentValues.documentName);
      formData.append("serviceTaskId", currentServiceTask.serviceTaskId);
      formData.append("clientId", currentServiceTask.clientId);
      formData.append("imageFile", documentValues.imageFile);
      formData.append("imageName", documentValues.imageName);
      formData.append("imageSrc", documentValues.imageSrc);
      formData.append("folderId", currentServiceTask.folderId);
      formData.append("companyId", userCompanyId);

      applicationAPI()
        .createDocument(formData)
        .then(() => {
          handleSuccess("Document Uploaded");
          setBtnSubmit(true);
          setDocumentModalVisible(false);
          resetDocumentForm();
        })
        .catch(() => {
          handleError("Error in uploading document");
          setBtnSubmit(true);
        });
    }
  };

  const applicationAPI = () => {
    return {
      createDocument: (formData) =>
        axios.post(config.APIACTIVATEURL + config.CREATEDOCUMENT, formData, {
          ...headerconfig,
        }),
      deleteDocument: (id) =>
        axios.delete(config.APIACTIVATEURL + config.DELETEDOCUMENT + "/" + id, {
          ...headerconfig,
        }),
    };
  };
  const onDelete = (id) => {
    if (window.confirm("Are you sure to delete this document?")) {
      applicationAPI()
        .deleteDocument(id)
        .then(() => {
          handleSuccess("Document deleted successfully");
          GetDocuments(currentServiceTask.serviceTaskId);
        })
        .catch(() => handleError("Error in deleting document"));
      GetDocuments(currentServiceTask.serviceTaskId);
    }
  };
  const GetDocuments = (serviceTaskId) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETDOCUMENT +
          "?serviceTaskId=" +
          serviceTaskId,
        headerconfig
      )
      .then((response) => setDocuments(response.data.data.data))
      .catch(() => handleError("Error fetching documents"));
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";
  useEffect(() => {}, [documents]);

  return (
    <Modal show onHide={() => setDocumentModalVisible(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleDocumentSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Document Name</label>
            <input
              type="text"
              name="documentName"
              value={documentValues.documentName}
              onChange={handleDocumentInputChange}
              className={"form-control" + applyErrorClass("documentName")}
              placeholder="Enter Document Name"
            />
            {isSubmitClicked && !documentValues.documentName && (
              <div className="validationerror">Please enter document name</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Upload Document</label>
            <input
              className="form-control"
              type="file"
              name="imageFile"
              onChange={handleImageChange}
            />
            {isSubmitClicked && !documentValues.imageFile && (
              <div className="validationerror">Please select a document</div>
            )}
          </div>

          <div className="mb-3  d-flex justify-content-end">
            <Button type="submit" variant="primary" disabled={!btnSubmit}>
              Upload Document
            </Button>
          </div>
          <div className="mt-4">
            <h5>Uploaded Documents</h5>
            <table className="table">
              <thead>
                <tr>
                  <th>Document Name</th>
                  <th>Uploaded Document</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documents.length > 0 ? (
                  documents.map((doc) => (
                    <tr key={doc.documentId}>
                      <td>{doc.documentName}</td>
                      <td>
                        {doc.imageSrc ? (
                          <a
                            href={doc.imageSrc}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                        ) : (
                          "No document uploaded"
                        )}
                      </td>
                      <td>
                        <ul className="list-inline hstack gap-2 mb-0">
                          <li
                            className="remove-item-btn"
                            onClick={() => onDelete(doc.documentId)}
                          >
                            <i className="ri-delete-bin-fill text-muted" />
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No documents uploaded yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
}
